import { render, staticRenderFns } from "./custimizeIframe.vue?vue&type=template&id=1041bd18&scoped=true"
import script from "./custimizeIframe.vue?vue&type=script&lang=js"
export * from "./custimizeIframe.vue?vue&type=script&lang=js"
import style0 from "./custimizeIframe.vue?vue&type=style&index=0&id=1041bd18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1041bd18",
  null
  
)

export default component.exports